import Grid from '@material-ui/core/Grid';
import { IProps } from '../../interfaces/IProps';

export const ErrorBoundary = ({ children }: IProps): JSX.Element => {
  return (
    <Grid container spacing={1}>
      <Grid item md={12} xs={12}>
        {children}
      </Grid>
    </Grid>
  );
};
